import { ApiEndpointClient } from './resource-client';
const VALUATION_API_PREFIX = 'valuation-api/v1';
export class ReferencesClient extends ApiEndpointClient {
    http;
    constructor(http) {
        super(http, VALUATION_API_PREFIX);
        this.http = http;
    }
    getReferenceFields = async (options) => {
        return this.get('/reference-fields', { signal: options?.signal });
    };
    getReferenceChoices = async ({ valuationId }, options) => {
        return this.get(`/valuations/${valuationId}/reference-choices`, { signal: options?.signal });
    };
}
